module.exports = __webpack_public_path__ + "static/media/SP_S_Jacquard_Palestro_DK Grey_Bordeaux.45744e64.png";